export const checkSession = async () => {
  try {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const expiry = payload.exp;
      const now = Math.floor(Date.now() / 1000);
      if (expiry < now) {
        sessionStorage.removeItem("accessToken");
        window.location.href = "/login"; // force redirect
      }
    }
  } catch (error) {
    sessionStorage.removeItem("accessToken");
    window.location.href = "/login"; // force redirect
  }
};
